import { IIconBase } from '..'

const verifyIcon = ({
  color = '#198754',
  height = 10,
  width = 10,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 10 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/verify'>
        <g id='verify'>
          <path
            id='Vector'
            d='M3.49121 4.99954L4.49538 6.00788L6.50788 3.99121'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M4.47871 1.02129C4.76621 0.775456 5.23704 0.775456 5.52871 1.02129L6.18704 1.58796C6.31204 1.69629 6.54538 1.78379 6.71204 1.78379H7.42038C7.86204 1.78379 8.22454 2.14629 8.22454 2.58796V3.29629C8.22454 3.45879 8.31204 3.69629 8.42038 3.82129L8.98704 4.47962C9.23288 4.76712 9.23288 5.23796 8.98704 5.52962L8.42038 6.18796C8.31204 6.31296 8.22454 6.54629 8.22454 6.71296V7.42129C8.22454 7.86296 7.86204 8.22546 7.42038 8.22546H6.71204C6.54954 8.22546 6.31204 8.31296 6.18704 8.42129L5.52871 8.98796C5.24121 9.23379 4.77038 9.23379 4.47871 8.98796L3.82038 8.42129C3.69538 8.31296 3.46204 8.22546 3.29538 8.22546H2.57454C2.13288 8.22546 1.77038 7.86296 1.77038 7.42129V6.70879C1.77038 6.54629 1.68288 6.31296 1.57871 6.18796L1.01621 5.52546C0.774544 5.23796 0.774544 4.77129 1.01621 4.48379L1.57871 3.82129C1.68288 3.69629 1.77038 3.46296 1.77038 3.30046V2.58379C1.77038 2.14212 2.13288 1.77962 2.57454 1.77962H3.29538C3.45788 1.77962 3.69538 1.69212 3.82038 1.58379L4.47871 1.02129Z'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default verifyIcon
